function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 34300"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29507"
}, /*#__PURE__*/React.createElement("path", {
  d: "M446 882a.815.815 0 0 1-.815-.815v-10.37a.815.815 0 1 1 1.63 0v10.37c0 .45-.364.815-.815.815Z",
  fill: "#2e83ff",
  fillRule: "evenodd",
  "data-name": "Path 48411"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 29508"
}, /*#__PURE__*/React.createElement("path", {
  d: "M451.185 876.815h-10.37a.815.815 0 1 1 0-1.63h10.37a.815.815 0 1 1 0 1.63Z",
  fill: "#2e83ff",
  fillRule: "evenodd",
  "data-name": "Path 48412"
})));
const SvgAdd = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "440 870 12 12",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add.6ebea3e6.svg";
export { ForwardRef as ReactComponent };